export const qrReaderStyle = {
  width: '100%',
};
